<template>
  <div class="can-pedalsure hp-block-container">
    <h2 class="hp-block-title">What our road bike insurance covers</h2>
    <div class="element-container hp-prose">
      <p>
        If you regularly use a bike on the road, road bike insurance is
        important to help you feel protected.
      </p>
      <p>
        We cover all types of road bike, with values from £400 to cover your
        most trusted entry level commuting machine right up to £15,000 to cover
        your full carbon, hyper aero superbike.
      </p>
      <p>
        Pedalsure insurance covers your road bike against theft, and against
        accidental damage with Theft and Accidental Damage cover. You can add
        cover for your accessories, like bike computers and helmets, and for you
        too: personal injury cover, and third party liability cover to protect
        yourself if someone makes a claim against you after an incident on the
        road.
      </p>
      <p>
        Road riding is covered, and so are sportives where no winner is
        selected, with no extra cover needed. Riding overseas? Add worldwide
        cover for up to 30 or 60 days a year.
      </p>
      <p>
        Taking part in an organised race, time trial or triathlon where a winner
        is selected? Add the Competition &amp; Racing Use option to your policy,
        at an additional premium, for cover while you compete.
      </p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.can-pedalsure {
  border-top: 1px solid $ps-border;
  border-bottom: 1px solid $ps-border;
}

.title {
  text-align: center;
  font-family: $family-regular;
  margin: 20px 0 0 0;
  font-size: 1.6rem;
  @include tablet {
    margin: 50px 0;
    font-size: 2.5rem;
  }
}
.subtitle {
  color: $ps-gray;
  line-height: 2rem;
}
</style>
